<template>
  <b-modal
    v-if="tracks != null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <h1>{{ Translations.sections.tracks.edition.styles }}</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTracks">Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <div class="form-container search">
          <input type="text" ref="inputSearch" maxlength="100" placeholder="Search style" v-model="searchData.searchTerm" @change="searchDelay(150)" />
          <Button :empty="true" :noBorder="true" @click.prevent="searchDelay(0)">
            <i class="fas fa-search"></i>
          </Button>
        </div>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingStyles"></WaitingBlock>
          <template
            v-else-if="searchResult != null && searchResult.dataItem != null && searchResult.dataItem.length > 0 && filteredStyles.length > 0"
          >
            <div v-for="parentStyle in filteredStyles" :key="parentStyle.id">
              <div class="style-container">
                <i
                  :class="[isStyleReduced(parentStyle.id) ? 'fas fa-angle-right' : 'fas fa-angle-down' ]"
                  @click="toggleReducedStyles(parentStyle.id)" style=" margin-right: 5px"
                ></i>
                <i :class="['far', selectedStyles[parentStyle.id] === undefined ? 'fa-square':'fa-check-square']"
                   @click.prevent="toggleStyle(parentStyle)" style=" cursor: pointer"></i>
                <span class="name" ><strong>{{ parentStyle.name }}</strong></span>
              </div>
              <div v-if="!isStyleReduced(parentStyle.id)">
                <div
                  v-for="style in parentStyle.children"
                  :key="style.id"
                  class="style-container --child"
                  @click.prevent="toggleStyle(style)"
                >
                  <i style=" margin-left: 5px"
                    :class="['far', selectedStyles[style.id] === undefined ? 'fa-square':'fa-check-square']"
                  ></i>
                  <span class="name">{{style.name}}</span>
                </div>
              </div>
            </div>
          </template>
          <div v-else class="no-result-container">
            <header>
              <strong>No style matching your search criteria</strong>
            </header>
            <div class="form-container" v-if="modalState.hasSearchProcessed && !noModalUpdate">
              <div class="creation-form form-container-line-space">
                <span><label class="creation-title">Create a new style</label></span>
                <span><input type="text" v-model="searchData.searchTerm" placeholder="Add a new  style" /></span>
                <span style=" white-space: nowrap;">
                  <b-form-group  :placeholder="'Style parent'" >

                  <b-form-select id="id"
                                 name="name"
                                 value-field="id"
                                 text-field="name" v-model="creationData.ParentStyleID" :options="parentStyles" >
                  </b-form-select>
                     <Button :empty="true" :noBorder="true" @click.prevent="createStyle()" :disabled="modalState.isCreatingStyle"><i class="fas fa-plus"></i></Button>
                </b-form-group>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedStylesData.length>0">
          <header>{{selectedStylesData.length}} selected styles :</header>
          <section>
            <div
              v-for="style in selectedStylesData.styles"
              :key="style.id"
              :class="['badge', 'style-badge',{'selected' : selectedStyles[style.id] === undefined}]"
            >
              <span class="name">{{style.name}}</span>
              <span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleStyle(style)"></i>
              </span>
            </div>
          </section>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorStyles",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    selectedStylesData() {
      return {
        length: Object.keys(this.selectedStyles).length,
        styles: Object.values(this.selectedStyles).sort(function(a, b) {
          return a.displayOrder - b.displayOrder;
        })
      };
    },
    filteredStyles() {
      var str = (this.searchData.searchTerm || "").trim();
      if (str == null || str == "") return this.searchResult.dataItem || [];
      str = this.normalizeSearchTerm(str);
      str = this.normalizeSearchTerm(str);

      return (this.searchResult.dataItem || [])
        .map(parentStyle => {
          const parent = { ...parentStyle };
          parent.children = parent.children
            .filter(style => this.normalizeSearchTerm(style.name).includes(str))
            .sort(style => style.name);

          return parent;
        })
        .filter(parentStyle => parentStyle.children.length > 0)
        .sort(parentStyle => parentStyle.name);
    }
  },
  mounted() {
    this.search();
    // Set search input autofocus
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null,
    noModalUpdate: true,
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingStyles: false,
        delayedSearch: null,
        isCreatingStyle: false
      },
      creationData: {
        name: null,
        ParentStyleID: null
      },
      tracks: [],
      selectedStyles: {},
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      },
      reducedStyles: [],
      parentStyles: []
    };
  },
  methods: {
    createStyle() {

      if(this.searchData.searchTerm && this.creationData.ParentStyleID != null && this.creationData.ParentStyleID != undefined) {
        this.creationData.name = this.searchData.searchTerm;
        this.modalState.isCreatingStyle = true;
        HTTP.post(Apis.parameters.style , this.creationData)
            .then(this.createEnd)
            .catch(this.createError)
            .then(this.createCompleted)
      }

    },
    createEnd(response) {
      this.creationResult = response.data;
      if (this.creationResult.dataItem != null) {
        this.searchData.searchTerm = this.creationResult.dataItem.name,
          //  this.toggleLabel(this.creationResult.dataItem);
        this.search();
        this.modalState.isCreatingStyle = false;
        this.creationData.name = "";
      }
    },
    createError(error) {
      this.creationResult = error.response.data;
    },
    createCompleted(response) { this.modalState.isCreatingStyle = false; },
    normalizeSearchTerm(str) {
      return (str || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    show() {
      this.$refs.modal.show();
    },
    edit(styles) {
      this.selectedStyles = styles && styles.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});

      this.show();
    },
    editForTracks(tracks) {
      var tmpStyles = {};
      this.tracks = tracks;
      if (this.tracks.length === 1) {
        for (var i = 0; i < (this.tracks[0].styles || []).length; i++) {
          tmpStyles[this.tracks[0].styles[i].id] = this.tracks[0].styles[i];
        }
      }

      this.selectedStyles = tmpStyles;
      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingStyles = true;
      this.creationData.name = this.searchData.searchTerm;
      try {
        HTTP.get(Apis.parameters.styles)
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data;
      if (this.parentStyles.length === 0 ){

        this.parentStyles= response.data.dataItem;
        this.parentStyles=[{ id: null, name: 'Please select a Parent Style' },].concat(this.parentStyles)

      }
      // console.log('search result :', this.searchResult);
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingStyles = false;
      this.modalState.hasSearchProcessed = true;
      this.creationData.name = this.searchData.searchTerm;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
      var result = null;

      if (this.noModalEdit) {
        this.cancelModal();
        this.$emit("newValue", "styles", this.selectedStylesData.styles);
        return;
      }

      try {
        var data = {
          stationUid: this.stationUid,
          keys: this.trackUids,
          values: this.selectedStylesData.styles.map(item => {
            return { styleId: item.id };
          })
        };
        result = await HTTP.post(Apis.library.tracks.update.styles, data);
        if (result.data.dataItem != null) {
          for (var idxTrack in this.tracks) {
            var track = this.tracks[idxTrack];
            var uid = track.uid;
            if (uid === undefined) continue;
            var updatedTrack = result.data.dataItem[uid];
            if (updatedTrack != null) {
              track.styles = updatedTrack.styles || [];
              track.warnings = updatedTrack.warnings;
              track.isFilled = updatedTrack.isFilled;
              this.cancelModal();
            }
          }
        }
      } catch (error) {
        result = error.response.data;
        // console.log("Update Result Error:", error);
      }
      if (result != null && result.errors && result.errors.length == 0) {
        this.cancelModal();
      } else {
        // an error occured : show it
      }
    },
    toggleStyle(style) {
      // console.log(style);
      style.isSelected = !style.isSelected;

      if (this.selectedStyles[style.id] != null) {
        Vue.delete(this.selectedStyles, style.id);
      } else {
        if (!this.multiselect) {
          this.selectedStyles = {};
        }

        const newStyle = style;
        const { id } = style;
        newStyle.displayOrder = new Date().getTime();

        this.selectedStyles = { ...this.selectedStyles, [style.id]: style };

        // this.$set(
        //   this.selectedStyles,
        //   style.id,
        //   Object.assign({ displayOrder: new Date().getTime() }, style)
        // );
      }

      // console.log('selected styles :', this.selectedStyles);
    },
    toggleReducedStyles(id) {
      // if styled id already in toggleList, remove it

      const isReduced = this.reducedStyles && this.reducedStyles.find(el => el === id);
      if (isReduced !== undefined) {
        this.reducedStyles = [...this.reducedStyles].filter(el => el !== id);
        return;
      }

      this.reducedStyles = [...this.reducedStyles, id];
    },
    isStyleReduced(id) {
      return this.reducedStyles && this.reducedStyles.includes(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.style-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  &.--child {
    margin-left: 10px;
    cursor: pointer;
  }
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
.form-container-line-space{
  line-height: 300%;
}
</style>
